import gql from 'graphql-tag'

export const GET_CONTACT = gql`
  query GetContact {
    contact {
      businessCustomer {
        attestEnabled
        companyName
      }
      customer {
        erpIdentifier
      }
      firstName
      lastName
      superUser
      connectedContacts {
        id
      }
      email
      visibility {
        showAddresses
        showAttest
        showContacts
        showServices
        showPreOrder
        showExternalOrders
        showInvoices
      }
    }
  }
`
